import * as yup from 'yup';

export const CheckBoxDateAndTimeSchema = yup.object({
  selected: yup.boolean().optional().default(false),
  dateAndTime: yup.mixed().when('selected', {
    is: true,
    then: yup.date().required(),
    otherwise: yup.mixed().oneOf([null]),
  }),
});
export type ICheckBoxDateAndTimeSchema = yup.InferType<typeof CheckBoxDateAndTimeSchema>;
